/**
 * home页面
 */
const mineLangCN = {
    myOrder: "我的订单(点击查看订单)",
    obligation: "待付款",
    waitingForDelivery:"待发货",
    shipped:"已发货",
    more:"售后服务",
    afterSales:"售后服务",
    addressManagement:"地址管理",
    accountsSndSecurity:"账户与安全",
    langSet:"语言设置",
    exitAccount:"退出账号",
    title:"退出",
    message:"你确定要退出吗？"
}

const mineLangEN = {
    myOrder: "My order (check your order here)",
    obligation: "Waiting for payment",
    waitingForDelivery:"Waiting For delivery",
    shipped:"Delivering",
    more:"After sales",
    afterSales:"After sales",
    addressManagement:"Address management",
    accountsSndSecurity:"Account and security",
    langSet:"language settings",
    exitAccount:"Log out",
    title:"Log out",
    message:"Are you sure you want to log out ?"
}

const langPackage = {
    cn:mineLangCN,
    en:mineLangEN
}

export {langPackage}
